'use strict';

define('app/setup/components',['knockout', 'text!../configuration/componentConfiguration.json', 'text!../configuration/loginComponentConfiguration.json', 'text!../configuration/itelematixComponentConfiguration.json', 'text!../configuration/fourFiveComponentConfiguration.json', 'text!../configuration/portalConfiguration.json', './registerComponentsFromConfig'], function (ko, componentConfiguration, loginComponentConfiguration, itelematixComponentConfiguration, fourFiveComponentConfiguration, portalConfiguration, registerComponentsFromConfig) {

		registerComponentsFromConfig(JSON.parse(componentConfiguration));
		registerComponentsFromConfig(JSON.parse(loginComponentConfiguration));
		registerComponentsFromConfig(JSON.parse(itelematixComponentConfiguration));
		registerComponentsFromConfig(JSON.parse(fourFiveComponentConfiguration));
		registerComponentsFromConfig(JSON.parse(portalConfiguration));
});
